export interface LinearTeamSummary {
	id: string
	name: string
	icon?: string | null
	color?: string | null
}

export interface ResolvedLinearTeam {
	name: string
	icon: string
	color: string | null
}

// Private teams are filtered out of the teams list, so fall back to the stored name.
export function resolveLinearTeam(
	teamId: string | null | undefined,
	teams: ReadonlyArray<LinearTeamSummary> | null | undefined,
	fallbackName?: string | null,
): ResolvedLinearTeam | null {
	const team = teamId ? teams?.find((it) => it.id === teamId) : undefined
	const name = team?.name ?? fallbackName
	if (!name) return null
	return {
		name,
		icon: team?.icon || "Team",
		color: team?.color ?? null,
	}
}
